import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Grid, Container } from '@material-ui/core';
import { Modal } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import FlightsService from '../../services/flights.servicse';
import NewFlightPopup from './NewFlightPopup';
import TextfieldGeneral from '../FormsUI/TextfieldGeneral';
import DateTimePickerFormsUI from '../FormsUI/DateTimePicker';
import AppButton from 'components/FormsUI/AppButton/appButton';

import './FindFlight.css';


function FindFlight(props) {
    const [errorMessage, setErrorMessage] = useState();
    const [showModal, setShowModal] = useState(false);
    const [flight, setFlight] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();


    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            var flight = await FlightsService.findFlightBeforeAdd(values);
            if (flight) {
                history.push("/FlightList",
                    { flightId: flight.id }
                );
            } else {
                setFlight(values);
                setShowModal(true);
                setIsLoading(false);
            }
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setShowModal(false);
    }

    const onRowSubmitted = async (value, action) => {
        history.push("/FlightList",
            { flightId: value.id }
        );
    }

    return (<>
        <Grid container>
            <Grid item xs={12}>
                <h2 id="addFlightTitle">Add flight details</h2>
            </Grid>
            <Grid item xs={12}>
                <Container maxWidth="md">
                    <div>
                        <Formik
                            initialValues={{ flightCode: '', flightDateTime: '' }}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(true);
                                handleSubmit(values);
                            }}
                            validationSchema={Yup.object().shape({
                                flightCode: Yup.string().required('Flight number is Required'),
                                flightDateTime: Yup.date().required('Flight Date Time is Required')
                                        .test('len', 'Year must be exactly 4 characters',
                                        val => val && val.getFullYear().toString().length === 4)
                            })}
                        >
                            {(props) => {
                                const {
                                    handleSubmit,
                                } = props;
                                return (
                                    <Form onSubmit={handleSubmit}  noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextfieldGeneral name="flightCode" label="Flight Code" id="flightCode" inputProps={{maxLength: 8}}></TextfieldGeneral>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <DateTimePickerFormsUI name="flightDateTime" label="Flight Date Time" id="flightDatePicker"/>
                                            </Grid>
                                        </Grid>
                                        {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}

                                        <div className="row" style={{ marginTop: '15px' }}>
                                            <div className="col-md-12">
                                                <AppButton 
                                                    type="submit" 
                                                    id="addFlightSubmitBtn" 
                                                    classes="rightBtn" 
                                                    label="NEXT" 
                                                    isLoading={isLoading}
                                                    style={{minWidth: 56}}
                                                 >
                                                 </AppButton>
                                            </div>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </Container>
            </Grid>
        </Grid>

        <div>
            <Modal show={showModal}>
                <Modal.Header >
                    <Modal.Title>Add flight</Modal.Title>
                    <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                </Modal.Header>
                <Modal.Body>
                    <NewFlightPopup props={props} onSubmitted={onRowSubmitted} flight={flight} />
                </Modal.Body>
            </Modal>
        </div>

    </>
    )
}

export default FindFlight;